import axios from 'axios'
import getString from '../config/strings'
import { DATA_HOST, REST_DATA_URL } from '../config/config'
import { get } from './axiosService'

class APIService {

  static getAllTariffs (token) {
    return new Promise(function (resolve, reject) {
      get(DATA_HOST + REST_DATA_URL, {}, token).then(function (result) {
        resolve(result)
      }).catch(function (error) {
        reject(error)
      })
    })
  }

  static saveTariff (record, token) {
    const baseurl = DATA_HOST + REST_DATA_URL

    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      timeout: 15000
    }

    return new Promise(function (resolve, reject) {
      axios.post(baseurl, record, config).then(function (result) {
        if (result.status === 201) {
          resolve(result.data)
        } else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (error) {
        if (error && error.response && error.response.data && error.response.data.errors) {
          reject(new Error(error.response.data.errors.join(',')))
        } else {
          reject(error)
        }
      })
    })
  }

  static updateTariff (record, token) {
    const baseurl = DATA_HOST + REST_DATA_URL

    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      timeout: 15000
    }

    return new Promise(function (resolve, reject) {
      axios.put(baseurl + '/' + record.id, record, config).then(function (result) {
        if (result.status === 200) {
          resolve(result.data)
        } else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (error) {
        if (error && error.response && error.response.data && error.response.data.errors) {
          reject(new Error(error.response.data.errors.join(',')))
        } else {
          reject(error)
        }
      })
    })
  }

  static deleteTariff (id, token) {
    const baseurl = DATA_HOST + REST_DATA_URL

    const config = {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      timeout: 15000
    }

    return new Promise(function (resolve, reject) {
      axios.delete(baseurl + '/' + id, config).then(function (result) {
        if (result.status === 200) {
          resolve(result.data)
        } else {
          reject(new Error(getString('ERROR_HTTP_COMMUNICATION')))
        }
      }).catch(function (error) {
        reject(error)
      })
    })

  }
}

export default APIService